import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import BrandLogo from './BrandLogo';
import OrganizationSwitcher from './OrganizationSwitcher';
import '../styles/staff-dashboard.css';

/**
 * Shared VLSI Expert staff chrome for all internal admin pages.
 */
const StaffPageShell = ({
  title,
  subtitle,
  backTo = '/dashboard',
  backLabel = 'Dashboard',
  wide = false,
  children,
  actions = null,
}) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="staff-home">
      <div className={`staff-home-inner ${wide ? 'staff-home-inner--wide' : ''}`}>
        <header className="staff-topbar">
          <div className="staff-topbar-brand">
            <BrandLogo size="sm" />
            <div className="min-w-0">
              <h1 className="staff-topbar-title">{title}</h1>
              {subtitle ? <p className="staff-topbar-sub">{subtitle}</p> : null}
            </div>
          </div>
          <div className="staff-topbar-actions">
            <OrganizationSwitcher />
            {actions}
            <button
              type="button"
              className="staff-nav-link"
              onClick={() => navigate(backTo)}
            >
              {backLabel}
            </button>
            <button type="button" className="staff-logout" onClick={handleLogout}>
              Sign out
            </button>
          </div>
        </header>

        <div className="staff-page-body">{children}</div>
      </div>
    </div>
  );
};

export default StaffPageShell;
